module.exports = "static/assets/06fd0604a4bf62a2b706edc23e49a086.mp3";